import {Component} from '@angular/core';
import superMarketBudgetLogsConfig from '../../../table/configs/super_market_budget_logs.json';


@Component({
  selector: 'app-sm-logs',
  templateUrl: './sm-logs.component.html'
})

export class SMLogsComponent {
  config: any;

  constructor() {
    this.config = superMarketBudgetLogsConfig;
  }

}
